import { render, staticRenderFns } from "./CustomIconModal.vue?vue&type=template&id=55497bbd&scoped=true"
import script from "./CustomIconModal.vue?vue&type=script&lang=js"
export * from "./CustomIconModal.vue?vue&type=script&lang=js"
import style0 from "./CustomIconModal.vue?vue&type=style&index=0&id=55497bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55497bbd",
  null
  
)

export default component.exports